import { DateFilter } from '../../../components/DateRangePicker';
import { ApiService } from '../../ApiService';
import { InterviewerAnalytics } from '../../../entities/candidate_experience/InterviewerAnalytics';

export class InterviewerAnalyticsService {
  public static get(
    filter_selector: string,
    job_names: string[],
    department_names: string[],
    benchmark_type: string,
    dateRange: DateFilter,
  ): Promise<InterviewerAnalytics> {
    return ApiService.get<InterviewerAnalytics>(
      '/api/candidate_experience/interviewer_analytics',
      {
        filter_selector,
        job_names,
        department_names,
        benchmark_type,
        start_date: dateRange.start.toJSON(),
        end_date: dateRange.end.toJSON(),
        date_range: dateRange.range,
      },
    );
  }
}
